export default "__VITE_ASSET__ee08b729__"